<template>
  <LinkCard
    :icon="iconComp"
    :image="thumbnail"
    :title="$path('title', value)"
    :badges="badges"
    :is-list="isList"
    :to="$attrs.to || { name: 'post-edit', params: { id: value.id } }"
  >
    <template #subtitle>
      <StatusIndicator v-bind="status" />
    </template>
  </LinkCard>
</template>

<script>
import LinkCard from '@/components/LinkCard'
import StatusIndicator from '@/components/StatusIndicator'

export default {
  props: {
    value: Object,
    icon: {
      type: Array,
      default: () => ['fal', 'newspaper'],
    },
    tags: {
      type: Array,
      default: () => [],
    },
    theme: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    iconComp() {
      return this.icon[0] instanceof Array ? this.icon[0] : this.icon
    },
    isList() {
      return this.theme === 'list'
    },

    thumbnail() {
      const items = this.$path('value.media.cover') || []
      let item = items.find(({ type }) => type.startsWith('image'))

      if (!item) {
        //check if item is video, and use api to get thumbnail
        item = items.find(({ type }) => ['vimeo', 'youtube'].includes(type))
        if (item) {
          item.url = `/api/media/thumbnail?url=${item.url}`
        }
      }

      if (!item) return

      return item.url
    },

    status() {
      if (this.value.isPublished) return { label: this.$t('published'), status: 'success' }
      return { label: this.$t('unpublished'), status: 'error' }
    },
    badges() {
      return [
        this.value.demo ? { theme: 'warning', value: this.$t('demo') } : null,
        ...this.tags.map(tag => ({ theme: 'primary', value: tag })),
      ].filter(Boolean)
    },
  },
  components: {
    LinkCard,
    StatusIndicator,
  },
}
</script>
